
























import { Component, Prop, Vue } from 'vue-property-decorator'
import * as modules from '../../../store/decorator'
import { uuid, isOnline, localForage } from '../../../utils/services'
import { values, filter } from 'lodash'
import Survey from '../../../class/survey'
import Upload from '../../../class/upload'
import headers from '../../data/datatable-headers-data'

@Component
export default class SurveyQueue extends Vue {

    @Prop(Object) network!: any

    data: Array<object> = []
    ids: any = {}

    async mounted() {

        this.data = await localForage.getAllSurveys();
    }

    get headers() {
        return headers
    }

    get surveyLocalStorageData() {
        if( document.querySelectorAll('.Upload.Queue').length ) {
            if( filter(values(this.data), ['network', this.network.code]).length > 0 ) {
                document.querySelectorAll('.Upload.Queue')[0].innerHTML = '('+ filter(values(this.data), ['network', this.network.code]).length +')';
            } else {
                document.querySelectorAll('.Upload.Queue')[0].innerHTML = '';
            }
        }

        return filter(values(this.data), ['network', this.network.code])
    }

    async removeQueue(uuid: any) {
        if (window.confirm('Are you sure you want to delete?') === false) {
            return;
        }
        localForage.surveys.removeItem(uuid)
        localForage.files.removeItem(uuid)
        localForage.referencenumbers.removeItem(uuid)

        this.data = await localForage.getAllSurveys()

        if( document.querySelectorAll('.Upload.Queue').length ) {
            if( filter(values(this.data), ['network', this.network.code]).length > 0 ) {
                document.querySelectorAll('.Upload.Queue')[0].innerHTML = '('+ filter(values(this.data), ['network', this.network.code]).length +')';
            } else {
                document.querySelectorAll('.Upload.Queue')[0].innerHTML = '';
            }
        }
    }

    editQueue(uuid: any) {
        localForage.getSurveyItem(uuid).then((res: any) => {
            if (!res) {
                return;
            }
            
            var network = 'wastewater';
            if (res.network == 'SW') network = 'stormwater';
            if (res.network == 'WS') network = 'watersupply';
            
            const targetRoute = `/${network}/new`;
            const targetQuery = {
                type: res.type,
                uuid: uuid
            };
            
            // Check if we're already on the target route
            if (this.$route.path === targetRoute && this.$route.query.uuid === uuid) {
                // Already on the same route with same UUID - force reload
                window.location.href = `${targetRoute}?type=${res.type}&uuid=${uuid}`;
                return;
            }
            
            // Navigate to the edit route
            try {
                this.$router.push({
                    path: targetRoute,
                    query: targetQuery
                });
            } catch (error) {
                // Handle navigation errors gracefully
                window.location.href = `${targetRoute}?type=${res.type}&uuid=${uuid}`;
            }
        }).catch((error) => {
        });
    }

    async sync() {

        if (!await isOnline()) {
            return modules.root.noConnectionAlert()
        }

        if (!this.surveyLocalStorageData.length) {
            return modules.root.syncSuccessAlert()
        }

        // Prevent multiple sync operations
        if (this.isSyncing) {
            return modules.root.errorAlert()
        }
        this.isSyncing = true

        const totalSurveys = this.surveyLocalStorageData.length
        let completedSurveys = 0
        const failedSurveys = []

        modules.root.loadingAlert(`Syncing survey 1 of ${totalSurveys}`)

        try {
            for (const item of this.surveyLocalStorageData as Array <any> ) {
                try {
                    completedSurveys++
                    modules.root.loadingAlert(`Syncing survey ${completedSurveys} of ${totalSurveys}`)

                    const uuid = item.surveyId
                    const files = await localForage.getFilesItem(uuid)
                    let uploadSuccess = false
                    let filesUploaded = false
                    let surveyPosted = false

                    // Check and reformat clientContact if it's an array
                    // if (item.data && item.data.details && item.data.details.attributes0 && item.data.details.attributes0.clientContact) {
                    //     if (Array.isArray(item.data.details.attributes0.clientContact)) {
                    //         item.data.details.attributes0.clientContact = item.data.details.attributes0.clientContact.join(', ')
                    //     }
                    // }

                    // Step 1: Get upload ID and post survey (only once)
                    if (await localForage.getReferenceNumberItem(uuid) == null) {
                        const response = await this.$http.get(`${process.env.VUE_APP_DOT_NET_API_BASE_URL}${process.env.VUE_APP_DOT_NET_API_UPLOAD_ID}/${ modules.user.customerDetail.customerId }`)
                        item.uploadId = response.data;
                        let filesTemp = [];
                        item.files.forEach(function(v, k) {
                            let gFileType = 'V';
                            if( v.match(/.(jpg|jpeg|png|gif)$/i) ) {
                                gFileType = 'I';
                            }
                            let newName = 'RM_'+ item.uploadId +'_'+ gFileType +'_'+ v;
                            filesTemp.push(newName);
                        });
                        item.files = filesTemp;
                        
                        const surveyResponse = await new Survey(this.$http).post(item)
                        await localForage.referencenumbers.setItem(uuid, surveyResponse.data.referenceNo)
                        surveyPosted = true
                    } else {
                        surveyPosted = true // Already posted in previous attempt
                    }

                    // Ensure uploadId is always available
                    if (!item.uploadId) {
                        const response = await this.$http.get(`${process.env.VUE_APP_DOT_NET_API_BASE_URL}${process.env.VUE_APP_DOT_NET_API_UPLOAD_ID}/${ modules.user.customerDetail.customerId }`)
                        item.uploadId = response.data;
                    }

                    // Step 2: Upload files (only once)
                    let fileImageCount = 0
                    let fileVideoCount = 0
                    
                    let refNo = await localForage.getReferenceNumberItem(uuid) as string
                    const upload = new Upload(this.$http, item.uploadId, refNo)
                    modules.root.createCancelToken()
                    
                    const clientIds = await upload.getClientIds(modules.user.customerDetail.code, modules.user.userDetail.email, modules.root.cancelSource.token, refNo, item.uploadId)
                    
                    // Extract plain object from Vue observer if needed
                    const plainClientIds = JSON.parse(JSON.stringify(clientIds))
                    this.ids = plainClientIds

                    if (files !== null && !filesUploaded) {
                        for (const file of files as Array <any> ) {
                            await upload.storeSurveyItem(file, refNo, item.uploadId);

                            if( file['type'].split('/')[0] === 'image' ) {
                                fileImageCount++;
                            } else {
                                fileVideoCount++;
                            }
                        }
                        filesUploaded = true
                    }

                    // Step 3: Final submission with retry mechanism
                    const maxRetries = 3
                    for (let attempt = 1; attempt <= maxRetries; attempt++) {
                        try {
                            if (surveyPosted) {
                                const userResponse = await this.$http.get(`${ process.env.VUE_APP_DOT_NET_API_BASE_URL }${ process.env.VUE_APP_DOT_NET_API_CLIENT_V3_DETAILS }/${ modules.user.userDetail.email }`)
                                
                                await this.$http.put(process.env.VUE_APP_V3_SURVEY_SUBMIT, {
                                    fieldData: item,
                                    id: userResponse.data[0].id,
                                    reticIds: plainClientIds,
                                    tallyTotal: {
                                        'Image': fileImageCount,
                                        'Video': fileVideoCount
                                    },
                                    inspectionPurpose: item.data.details.attributes0.inspectionPurpose,
                                    projectReference: item.projectReference,
                                    assetId: item.assetNo,
                                    address: item.address,
                                    type: item.type
                                }, {
                                    headers: {
                                        Authorization: process.env.VUE_APP_V3_API_KEY
                                    }
                                })
                            }

                            // SUCCESS: Only now is it safe to cleanup
                            uploadSuccess = true
                            break // Exit retry loop on success

                        } catch (error) {
                            // eslint-disable-next-line no-console
                            console.error(`Final submission attempt ${attempt} failed for survey ${uuid}:`, error)
                            
                            if (attempt === maxRetries) {
                                throw error // Final attempt failed
                            }
                            
                            // Wait before retry (exponential backoff)
                            await new Promise(resolve => setTimeout(resolve, 1000 * attempt))
                        }
                    }

                    // Only cleanup after confirmed success
                    if (uploadSuccess) {
                        // Email notification preparation (keeping existing logic)
                        let mailSubject = `Manhole form submitted - ${ modules.user.customerDetail.code } - ${ modules.user.userDetail.organization } - ID #${ uuid }`;
                        let mailHeaders = 'Content-Type: multipart/mixed; boundary="retic_mailer"\r\n';
                            mailHeaders += 'MIME-Version: 1.0\r\n';
                            mailHeaders += 'From: ReticManager Upload<upload@reticmanager.com>\r\n';
                        let currentDate = Date.now();

                        // TODO: SEND EMAIL - FIRST NEED TO FIGURE OUT WHY CCTV EMAIL DOESN'T GO OUT
                        // await this.$http.post(process.env.VUE_APP_V3_CCTV_UPLOAD_SEND_RECEIPT, {
                        //     mailTo: 'upload@reticmanager.com',
                        //     mailHeaders: mailHeaders,
                        //     mailSubject: mailSubject,
                        //     customerName: modules.user.customerDetail.name,
                        //     uploadId: item.surveyId,
                        //     currentDate: currentDate,
                        //     userOrganization: modules.user.userDetail.organization,
                        //     userFullName: modules.user.userDetail.firstName +' '+ modules.user.userDetail.lastName,
                        // }, {
                        //     headers: {
                        //         Authorization: process.env.VUE_APP_V3_API_KEY
                        //     }
                        // });

                        // SAFE CLEANUP: Only after complete success
                        await localForage.surveys.removeItem(uuid)
                        await localForage.files.removeItem(uuid)
                        await localForage.referencenumbers.removeItem(uuid)
                    }

                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(`Failed to sync survey ${item.surveyId}:`, error)
                    failedSurveys.push({
                        surveyId: item.surveyId,
                        error: error.message || 'Unknown error'
                    })
                    // Continue with next survey instead of stopping entire sync
                }
            }

            // Update local data after sync
            this.data = await localForage.getAllSurveys()

            // Show appropriate completion message
            if (failedSurveys.length === 0) {
                modules.root.syncSuccessAlert()
            } else if (failedSurveys.length < totalSurveys) {
                // Show partial success - use generic error alert since custom messages aren't supported
                modules.root.errorAlert()
            } else {
                modules.root.errorAlert()
            }

        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Sync operation failed:', error)
            modules.root.errorAlert()
        } finally {
            this.isSyncing = false
        }
    }

    // Add sync state tracking
    isSyncing: boolean = false
}
